module.exports = __webpack_public_path__ + "static/media/UV-F.73da7bf3.jpg";